/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReleaseEmailUpdateRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {ReleaseEmailUpdateResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const releaseEmailUpdate = (request: ReleaseEmailUpdateRequest, options?: CashRequestOptions) => post<ReleaseEmailUpdateRequest, ReleaseEmailUpdateResponse>("/2.0/cash/release-email-update", request, {...options, rejectOnError: true })